import React, { useEffect } from "react";
import Data from "../../dummy";
import Cover from "../../common/Cover";
import TermsConditions from "./TermsConditions";

import { fetchTerms } from "../../../states/actions/fetchTerms";
import { useSelector, useDispatch } from "react-redux";
import useDocumentTitle from "../../../hooks/useDocumentTitle";
import LoadingScreen from "../../common/LoadingScreen";
import { useSearchParams } from "react-router-dom";
import useReferralLink from "../../../hooks/useReferralLink";

const Terms = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const referralLink = useReferralLink(
    searchParams.get("ref"),
    searchParams.get("compaign_name")
  );
  const { cover } = Data.terms;
  const dispatch = useDispatch();
  const data = useSelector((state) => state.fetchTerms.content);
  const isLoading = useSelector((state) => state.fetchTerms.isLoading);
  const isSiteSettingsLoading = useSelector(
    (state) => state.fetchSiteSettings.isLoading
  );
  const { content } = data;

  useEffect(() => {
    dispatch(fetchTerms({ ref: referralLink }));
  }, []);

  useDocumentTitle(data.page_title);
  return (
    <>
      {isLoading || isSiteSettingsLoading ? (
        <LoadingScreen />
      ) : (
        <>
          <Cover data={cover} content={content} />
          <TermsConditions content={content} />
        </>
      )}
    </>
  );
};

export default Terms;
